define('view/controller/booking/datetime/SidebarView',['require','view/controller/booking/datetime/DateTimeStepDefaultLayout','lib/theme/ThemeSettings'],function (require) {

    var LayoutView = require('view/controller/booking/datetime/DateTimeStepDefaultLayout');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Sidebar booking info view
     *
     * @class SidebarView
     */
    return LayoutView.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#datetime_booking_info_sidebar_list';
            }
            return '#datetime_booking_info_sidebar';
        },

        modelEvents: {
            'change': 'render'
        }

    });

});
